<template>
  <div class="relative">
    <!-- Close Button -->
    <button
        class="absolute top-6 right-5 z-50 bg-white p-3 rounded-full shadow-lg flex items-center justify-center hover:bg-gray-200 transition-all duration-300"
        @click="$emit('close')"
    >
      <img src="@/assets/icons/svg/Close_16x16.svg" alt="" class="w-6 h-6">
    </button>

    <!-- Swiper -->
    <swiper
        :modules="[Navigation, Pagination]"
        :slides-per-view="1"
        :space-between="10"
        :loop="true"
        :navigation="true"
        :pagination="{ clickable: true }"
        class="h-[90vh]"
    >
      <!-- Swiper Slide -->
      <swiper-slide v-for="(image, index) in props.images" :key="index">
        <div class="flex justify-center items-center h-full">
          <img
              :src="image.url"
              class="popup-image h-[80vh] object-cover mx-auto"
          />
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script setup>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

defineEmits(["close"]);

const props = defineProps({
  images: {
    type: Array,
    required: true,
  },
});
</script>

<style scoped>

:deep(.swiper-pagination-bullet-active) {
  background: black !important;
  transform: scale(1.2);
}

:deep(.swiper-button-prev),
:deep(.swiper-button-next) {
  width: 50px;
  height: 50px;
  background-color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.1);
  transition: background 0.3s ease-in-out, transform 0.2s ease-in-out;
}

:deep(.swiper-button-prev:hover),
:deep(.swiper-button-next:hover) {
  background-color: #f3f3f3;
}

:deep(.swiper-button-prev:after),
:deep(.swiper-button-next:after) {
  font-size: 20px;
  color: black;

}

:deep(.swiper-button-prev) {
  left: 20px;
}

:deep(.swiper-button-next) {
  right: 20px;
}

button {
  transition: transform 0.2s ease-in-out, background 0.2s ease-in-out;
}

button:hover {
  transform: scale(1.1);
  background-color: #e5e5e5;
}
</style>